import React, { useEffect, useState } from "react";
import { Form, Row, Col, Image, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
  ListItemText,
  Checkbox,
} from "@material-ui/core";
import SelectMany from "react-select";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Switch from "react-switch";
import MultipleImageUploadComponent from "../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import { Toggle } from "../../../../components/superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import SimpleReactLightbox from "simple-react-lightbox";
import { amApi } from "../../../../api/apiHelper";
import { errorAlert, successAlert } from "../../../../function/alert";
import { isEmpty } from "lodash";
import moment from "moment";
import MapSetupEvent from "../../../vendorOnboradingComponents/allScreens/MapSetup/MapSetupEvent";
import { videoUploadSize } from "../../../../config/Keys";
import AlertDialogProgress from "../../../reusableComponents/allPopupReusable/DialogProgression";
import TimeSlots from "./TimeSlots";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { RestaurantCard } from "../../../reusableComponents/RestaurantCard";
import { ReactCropperImageUpload } from "../../../reusableComponents/imageUploadReusableComponent/ReactCropperImageUpload";

const thumbnail = true;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const GeneralInformationExp = ({
  formik,
  expType,
  count,
  prevCopyTimings,
  cloneData,
  cloneExp,
  setExpClone,
  prevStartDate,
  prevEndDate,
  editMode,
  ...props
}) => {
  const history = useHistory();
  const pathName = history.location.pathname;

  const [state, setState] = useState({
    restaurant_video: [],
    video_url: "",
    progress: 0,
    actionButton: false,
  });
  const vendor = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user?.VendorUser : {};
  });

  const restaurant = useSelector((state) => {
    return !isEmpty(state.onboarding)
      ? state.onboarding?.restaurantDetails
      : {};
  });

  const [tagData, setTagData] = useState("");

  const [selectData, setSelectData] = useState({
    category: [],
    subCategory: [],
    classification: [],
  });


  const [minDate, setMinDate] = useState(moment().format("YYYY-MM-DD"));
  const [minEndDate, setMinEndDate] = useState();

  const handleStartDateChange = (e) => {
    formik.setFieldValue("startDate", e.target.value);
    formik.setFieldValue("endDate", "");
    setMinEndDate(e.target.value);
  };

  const addTags = () => {
    let arr =  formik.values.tags;
    if(arr.length){
        for(let i=0;i<arr.length;i++){
             if(arr[i] === tagData){
                 errorAlert(`experience tag already exist`)
             }else{
             formik.setFieldValue("tags", [...formik.values.tags, tagData]);
             setTagData("");
              }
           }
    }else {
    formik.setFieldValue("tags", [...formik.values.tags, tagData]);
    setTagData("");
    }}



  const removeTags = (name) => {
    let tags = formik.values.tags.filter((e) => e !== name);
    formik.setFieldValue("tags", tags);
  };

  const venueLocation = (data) => {
    formik.setFieldValue("venue", data);
    formik.setFieldValue("venueAddress", data.formatted_address);
  };

  const bankDocMultipleRemove = (indexId) => {
    let allImages = formik.values.photos.filter((item, index) => {
      return index !== indexId;
    });
    let thumbImage = formik.values.photoThumbnails.filter((item, index) => {
      return index !== indexId;
    });
    formik.setFieldValue("photos", allImages);
    formik.setFieldValue("photoThumbnails", thumbImage);
  };

  /*************************************
   * @DESC Multiple Video Upload
   ************************************/
  const uploadMultipleVideoFiles = (e) => {
    e.preventDefault();
    const vendor_id = vendor._id;
    const restaurant_name = restaurant.restaurant_name.split(" ").join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > videoUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else {
        if (state.restaurant_video && state.restaurant_video.length > 0) {
          if (state.restaurant_video[0].name === e.target.files[i].name) {
            return (flag = true);
          }
        }
        if (!flag) {
          data.append("file", e.target.files[i]);
        }
      }
    }
    var newData = e.target.files;
    if (!flag) {
      const setProgress = (percent) => {
        setState({ ...state, progress: percent });
      };
      amApi
        .post(`/upload-assets-video`, data, {
          onUploadProgress: (progressEvent) => {
            setProgress((progressEvent.loaded / progressEvent.total) * 100);
          },
        })
        .then((res) => {
          setState({
            ...state,
            restaurant_video: newData,
            video_url: res.data,
            actionButton: true,
          });
          formik.setFieldValue("videos", [res.data]);
          successAlert(`Restaurant Video Upload Successfully`);
        })
        .catch((err) => {
          errorAlert(`${err}`);
        });
    } else {
      errorAlert(`Can not upload the same video`);
    }
  };

  const multipleVideoResetFile = (e) => {
    let video_url = state.video_url;
    let restaurant_video = state.restaurant_video;
    video_url = "";
    restaurant_video = [];
    setState({
      ...state,
      restaurant_video: restaurant_video,
      video_url: video_url,
      actionButton: true,
    });
    formik.setFieldValue("videos", video_url);
  };

  const copyTimings = () => {
    if (
      (formik.values.startDate && formik.values.endDate) ||
      expType === "SPECIAL"
    ) {
      formik.setFieldValue("copyTimings", !formik.values.copyTimings);
    } else {
      errorAlert("Give start date and End date.");
    }
  };

  const copyRestAddress = () => {
    if (
      restaurant.restaurant_address &&
      restaurant?.location?.coordinates?.length
    ) {
      formik.setFieldValue("venueAddress", restaurant.restaurant_address);
      formik.setFieldValue("venue", {
        latitude: restaurant?.location?.coordinates[1],
        longitude: restaurant?.location?.coordinates[0],
      });
      formik.setFieldValue("copyAddress", !formik.values.copyAddress);
    } else {
      errorAlert("Restaurant Address Not Available");
    }
  };

  useEffect(() => {
    async function fetchData() {
      let cat = await amApi(
        `/category?code=${expType === "CURATED" ? "FLEXIBLE" : "FIXED"}`
      );
      let classification = await amApi(`/subcategory?code=CLASSIFICATION&status=APPROVED`);
      setSelectData({
        category: cat?.data || [],
        classification: classification?.data || [],
        subCategory: [],
      });
    }
    if (!pathName.includes("edit")) {
      fetchData();
    }
  }, [pathName]);

  const [clasfArr, setclasfArr] = useState([]);

  useEffect(() => {
    async function fetchData() {
      let cat = await amApi(
        `/category?code=${expType === "CURATED" ? "FLEXIBLE" : "FIXED"}`
      );
      let classification = await amApi(`/subcategory?code=CLASSIFICATION&status=APPROVED`);
      let subCat = await amApi(
        `/subcategory?category_id=${formik.values.category}&status=APPROVED`
      );
      setSelectData({
        category: cat?.data || [],
        classification: classification?.data || [],
        subCategory: subCat?.data || [],
      });
      AddNames(classification?.data);
    }
    if (!isEmpty(formik.values.category) && !isEmpty(expType)) {
      fetchData();
    }
  }, [formik.values.category, expType, count]);

  const AddNames = (_classification) => {
    let _clasfArr = [];
    _classification.map((i) => {
      _clasfArr.push({ _id: i._id, title: i.title });
    });
    setclasfArr(_clasfArr);
  };

  const [classificationName, setClassificationName] = useState(
    formik?.values?.classification || []
  );

  const classificationHandleChange = (event) => {
    if (cloneExp) {
      let _t = [];
      var clean = event.target.value.filter((arr, index, self) => {
        let _index = index;
        let _self = self.findIndex((t) => t._id === arr._id);
        if (_index !== _self) {
          _t.push(index);
          _t.push(_self);
          return false;
        } else {
          return index === self.findIndex((t) => t._id === arr._id);
        }
      });
      if (_t?.length) {
        _t.map((_i) => event.target.value.splice(_i, 1));
      }
      formik.setFieldValue("classification", event.target.value);
      setClassificationName(event.target.value);
      if (!event.target.value?.length) setExpClone();
    } else {
      formik.setFieldValue("classification", event.target.value);
    }
  };

  useEffect(() => {
    setClassificationName(formik.values.classification);
  }, [formik.values.classification]);

  useEffect(() => {
    if (formik.errors && formik.errors.name) {
      let nameElement = document.getElementById("name");
      nameElement.focus();
    } else if (formik.errors && formik.errors.description) {
      let descElement = document.getElementById("description");
      descElement.focus();
    } else if (formik.errors && formik.errors.tc) {
      let termAndConditionsElement = document.getElementById("tc");
      termAndConditionsElement.focus();
    }
  }, [count]);

  const onCompleteUpload = (files, thumbnails) => {
    formik.setFieldValue("photos", [...formik.values.photos, ...files]);
    formik.setFieldValue("photoThumbnails", [...formik.values.photoThumbnails, ...thumbnails]);
  };

  return (
    <Form>
      <Row>
        <Col sm={9}>
          <Row className="my-4">
            <Col sm={4}>
              <FormControl variant="outlined" className={"w-100"}>
                <InputLabel id="demo-simple-select-label-From">
                  Category
                </InputLabel>
                <Select
                  label="Category"
                  value={formik.values.category}
                  onChange={formik.handleChange}
                  name="category"
                  IconComponent={KeyboardArrowDownIcon}
                  disabled={pathName.includes("edit")}
                >
                  {selectData?.category.map((ele) => (
                    <MenuItem value={ele._id} key={ele._id}>
                      {ele.title}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  Select one category from above eg. Occasion
                </FormHelperText>
                {formik.errors.category && formik.touched.category ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.category}
                  </div>
                ) : null}
              </FormControl>
            </Col>
            <Col sm={4}>
              <FormControl variant="outlined" className={"w-100"}>
                <InputLabel id="demo-simple-select-label-From">
                  Sub Category
                </InputLabel>
                <Select
                  label="Sub-Category"
                  value={formik.values.subCategory}
                  onChange={formik.handleChange}
                  name="subCategory"
                  IconComponent={KeyboardArrowDownIcon}
                  disabled={pathName.includes("edit")}
                >
                  {selectData?.subCategory.map((ele) => (
                    <MenuItem value={ele._id} key={ele._id}>
                      {ele.title}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  Select one category from above eg. Birthday
                </FormHelperText>
                {formik.errors.subCategory && formik.touched.subCategory ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.subCategory}
                  </div>
                ) : null}
              </FormControl>
            </Col>
            <Col sm={4}>
              <FormControl variant="outlined" className={"w-100"}>
                <InputLabel id="demo-simple-select-label-From">
                  Classification
                </InputLabel>
                <Select
                  label="Classification"
                  value={classificationName}
                  onChange={classificationHandleChange}
                  defaultValue={classificationName}
                  name="classification"
                  multiple
                  IconComponent={KeyboardArrowDownIcon}
                  MenuProps={MenuProps}
                  renderValue={(selected) => {
                    let view = [];
                    selected.map((e) => {
                      view.push(e.title);
                    });
                    return view.join(", ");
                  }}
                >
                  {clasfArr.map((name) => (
                    <MenuItem key={name._id} value={name}>
                      <ListItemText primary={name?.title} />
                      <Checkbox
                        checked={classificationName.some(
                          (e) => e._id === name._id
                        )}
                      />
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  Select classification from above eg. Family
                </FormHelperText>
                {formik.errors.classification &&
                  formik.touched.classification ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.classification}
                  </div>
                ) : null}
              </FormControl>
            </Col>
          </Row>
        </Col>
        <Col lg={8}>
          <Form.Group>
            <TextField
              id="name"
              label="Experience Name"
              type="text"
              variant="outlined"
              className={`w-100 ${formik.errors.name && formik.touched.name ? "enError" : ""
                }`}
              name="name"
              helperText={
                formik.errors.name && formik.touched.name
                  ? formik.errors.name
                  : "Max 60 characters"
              }
              onChange={formik.handleChange}
              value={formik.values.name}
              onBlur={formik.handleBlur}
              disabled={pathName.includes("edit")}
              error={formik.errors.name && formik.touched.name}
              isInvalid={formik.errors.name && formik.touched.name}
            />
          </Form.Group>
          <Form.Group className="mb-0">
            <TextField
              id="description"
              label="Description"
              type="text"
              multiline
              rows="5"
              variant="outlined"
              className={`w-100  ${formik.errors.description && formik.touched.description
                ? "enError"
                : ""
                }`}
              name="description"
              helperText={
                formik.errors.description && formik.touched.description
                  ? formik.errors.description
                  : "Max 500 characters"
              }
              onChange={formik.handleChange}
              value={formik.values.description}
              onBlur={formik.handleBlur}
              error={formik.errors.description && formik.touched.description}
              isInvalid={
                formik.errors.description && formik.touched.description
              }
            />
          </Form.Group>
          {/* <Row className="pb-4 mt-3"> */}
          {/* <Col lg={6}>
              <div className="d-flex align-items-center">
                <Toggle
                  checked={formik.values.active}
                  toggleFunction={() => {
                    if (formik.values.active)
                      formik.setFieldValue("primary", false);
                    formik.setFieldValue("active", !formik.values.active);
                  }}
                />
                <div className="pl-2">
                  <div className="f12-500">Status</div>
                </div>
              </div>
            </Col> */}
          {/* <Col lg={6}>
              <div className="d-flex align-items-start">
                <Toggle
                  checked={formik.values.primary}
                  toggleFunction={() => {
                    if (formik.values.active) formik.setFieldValue("primary", !formik.values.primary)
                    else errorAlert("Please turn on the status.")
                  }
                  }
                  toggleFunction={() => {
                    if (formik.values.active)
                      formik.setFieldValue("primary", !formik.values.primary);
                    else errorAlert("Please turn on the status.");
                  }}
                />
                <div className="pl-2">
                  <div className="f12-500 mb-2">
                    Make this Experience Primary
                  </div>
                  <div className="f10-400 opacity5">
                    (Note you can make only one Experience primary)
                  </div>
                </div>
              </div>
            </Col> */}
          {/* </Row> */}
          <hr />
          <Form.Group>
            <TextField
              id="userBenefits"
              label="What do users get?"
              type="text"
              multiline
              rows="5"
              variant="outlined"
              className={`w-100`}
              name="userBenefits"
              helperText={
                formik.errors.userBenefits && formik.touched.userBenefits
                  ? formik.errors.userBenefits
                  : "Max 500 characters"
              }
              onChange={formik.handleChange}
              value={formik.values.userBenefits}
              onBlur={formik.handleBlur}
              error={formik.errors.userBenefits && formik.touched.userBenefits}
              onInvalid={
                formik.errors.userBenefits && formik.touched.userBenefits
              }
            />
          </Form.Group>
          <hr />
          <Row className="pb-4">
            <Col md={6} xs={8}>
              <TextField
                label="Experience Tags"
                variant="outlined"
                className="w-100"
                name="tags"
                onChange={(e) => setTagData(e.target.value)}
                value={tagData}
                helperText="Experience tags are used for user to search/filter events, you can add max. 3 tags per Experience."
              ></TextField>
            </Col>
            <Col xs={4} className="pt-2">
              {tagData.length == 0 || formik.values?.tags?.length > 2 ? null : (
                <>
                  <Button
                    variant="link"
                    className="d-flex align-items-center p-0 mb-4"
                    onClick={addTags}
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/add-blue.svg")}
                      alt="add"
                      title="add"
                      className="w-20px"
                    />
                    <span className="ml-2 f12-500 text-blue">Add</span>
                  </Button>
                </>
              )}
            </Col>
            <Col md={12}>
              <div className="d-flex flex-wrap mt-2">
                {formik?.values?.tags?.map((name, index) => {
                  return (
                    <div className="mb-3 mr-3" key={index}>
                      <div className="keywords_button">
                        <p>{name}</p>
                        <span className="ml-2" onClick={() => removeTags(name)}>
                          <SVG
                            src={require("../../../../assets/images/UserManagement/close.svg")}
                          />
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Col>
          </Row>
        </Col>
        <Col lg={12}>
          <hr />
          {/* <div className="f16-500 py-1">Allow Kids?</div> */}
          {/* <div className="f10-400 pb-4">
            (This may be relevant if you are a Bar and Night Club with min age
            to enter, you may still have to check the ID for the entrants)
          </div> */}
          <Row className="align-items-center pb-3">
            <Col md={2} xs={6}>
              <div className="f16-500">Age Restrictions</div>
            </Col>
            <Col md={10} xs={6}>
              <div className="d-flex align-items-center">
                <Toggle
                  checked={formik.values.ageRestriction}
                  toggleFunction={() =>
                    formik.setFieldValue(
                      "ageRestriction",
                      !formik.values.ageRestriction
                    )
                  }
                />
              </div>
            </Col>
            <div className="f10-400 pl-3 py-1 opacity5">
              (This may be relevant if your establishment is a Bar/ Night Club
              with min age to enter, you may still have to check the ID for the
              entrants)
            </div>
          </Row>
          {formik.values.ageRestriction ? (
            <>
              <Row className="align-items-center pb-3">
                <Col md={3}>
                  <div className="f16-500">Suitable For Age Groups</div>
                </Col>
                <Col md={9}>
                  <FormControl variant="outlined" className={"w134"}>
                    <Select
                      value={formik.values.minAge}
                      onChange={formik.handleChange}
                      inputProps={{
                        type: "number",
                        name: "minAge",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <MenuItem value={0} selected>
                        Select Age
                      </MenuItem>
                      <MenuItem value={18}>18</MenuItem>
                      <MenuItem value={21}>21</MenuItem>
                    </Select>
                  </FormControl>
                </Col>
              </Row>
            </>
          ) : null}

          <hr className="mb-5" />
          <Row className="pb-4">
            <Col lg={2}>
              <div className="f16-500">Status</div>
            </Col>
            <Col lg={3} className="d-flex">
              <div className="d-flex align-items-start ml-2 mr-2">
                <Toggle
                  checked={formik.values.active}
                  toggleFunction={() => {
                    if (formik.values.active)
                      formik.setFieldValue("primary", false);
                    formik.setFieldValue("active", !formik.values.active);
                  }}
                />
              </div>
            </Col>
          </Row>
          <hr />
          <Row className="pb-4 align-items-center">
            <Row className="w-100">
              <Col md={6} xl={6} xs={6} className="pb-3">
                <div className="f16-500 py-1 pl-3">Validity*</div>
              </Col>
              <Col md={4} xl={4} xs={4} className="pb-3 flexcenter">
                <Checkbox
                  onChange={copyTimings}
                  checked={formik.values.copyTimings}
                  style={{ color: "#EE3A23" }}
                />
                <div className={`f14-400 pr-2`}>Copy Business Hours</div>
              </Col>
            </Row>
            <Col md={3} xl={2} xs={6} className="pb-3">
              <TextField
                id="startDate"
                label="Start Date"
                variant="outlined"
                InputProps={{
                  inputProps: { min: minDate },
                }}
                type="date"
                defaultValue={minDate}
                className={`w-100 ${formik.errors.startDate && formik.touched.startDate
                  ? "enError"
                  : ""
                  }`}
                InputLabelProps={{
                  shrink: true,
                }}
                name="startDate"
                onChange={(e) => handleStartDateChange(e)}
                value={formik.values.startDate}
                onBlur={formik.handleBlur}
                isInvalid={formik.errors.startDate && formik.touched.startDate}
              />
              {formik.errors.startDate && formik.touched.startDate ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.startDate}
                </div>
              ) : null}
            </Col>
            <Col md={3} xl={2} xs={6} className="pb-3">
              <TextField
                id="endDate"
                label="End Date"
                variant="outlined"
                type="date"
                className={`w-100 ${formik.errors.endDate && formik.touched.endDate
                  ? "enError"
                  : ""
                  }`}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputProps: { min: minEndDate || formik?.values?.startDate },
                }}
                name="endDate"
                onChange={formik.handleChange}
                value={formik.values.endDate}
                onBlur={formik.handleBlur}
                isInvalid={formik.errors.endDate && formik.touched.endDate}
              />
              {formik.errors.endDate && formik.touched.endDate ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.endDate}
                </div>
              ) : null}
            </Col>
          </Row>
          <TimeSlots
            formik={formik}
            expType={expType}
            prevCopyTimings={prevCopyTimings}
            prevStartDate={prevStartDate}
            prevEndDate={prevEndDate}
            cloneData={cloneData}
          />
          <hr />
          <Row>
            <Col md={6} xl={6} xs={6} className="pb-3">
              <div className="f16-500 py-1">Venue Details</div>
            </Col>
            <Col md={4} xl={4} xs={6} className="pb-3 flexcenter">
              <Checkbox
                onChange={copyRestAddress}
                checked={formik.values.copyAddress}
                style={{ color: "#EE3A23" }}
              />
              <div className={`f14-400 pr-2`}> Copy Restaurant Address</div>
            </Col>
            {!formik.values.copyAddress ? (
              <>
                <Col lg={8}>
                  <MapSetupEvent
                    heading={
                      "Drop A Pin to Your Address Move the marker as required"
                    }
                    handleLocation={venueLocation}
                    defaultValue={formik?.values?.venue}
                    editAction={
                      editMode
                    }
                    // formik?.values?.venue && true
                  />
                </Col>
                <Col lg={8}>
                  <Form.Group>
                    <TextField
                      id="venueAddress"
                      label="Venue/Address/Location"
                      type="text"
                      multiline
                      rows="5"
                      variant="outlined"
                      className={`w-100 ${formik.errors.venueAddress &&
                        formik.touched.venueAddress
                        ? "enError"
                        : ""
                        }`}
                      name="venueAddress"
                      onChange={formik.handleChange}
                      value={formik.values.venueAddress}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.venueAddress &&
                      formik.touched.venueAddress ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.venueAddress}
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
              </>
            ) : (
              <></>
            )}
          </Row>
          <hr />
          <Row className="align-items-center pb-3">
            <Col md={6} xs={6}>
              <div className="f16-500">
                Do you serve food items for the experience?
              </div>
            </Col>
            <Col md={6} xs={6}>
              <div className="d-flex align-items-center">
                <div className="f12-400 mr-2">No</div>
                <Toggle
                  checked={formik.values.serveFood}
                  toggleFunction={() =>
                    formik.setFieldValue("serveFood", !formik.values.serveFood)
                  }
                />
                <div className="f12-400 ml-2">Yes</div>
              </div>
            </Col>
            {formik.values.serveFood && (
              <Col md={9} xs={6}>
                <Form.Group>
                  <TextField
                    id="foodItems"
                    label="Enter Food Items"
                    type="text"
                    variant="outlined"
                    multiline
                    rows="5"
                    className={"w-100 pt-2"}
                    name="foodItems"
                    onChange={formik.handleChange}
                    value={formik.values.foodItems}
                    onBlur={formik.handleBlur}
                  />
                </Form.Group>
              </Col>
            )}
          </Row>
          <hr />
          <Col md={12}>
            <div className="event-offer-image">
              <ReactCropperImageUpload
                title="Add Photo *"
                smallTitle=""
                onComplete={onCompleteUpload}
                combined={
                  (vendor?._id || "") +
                  "_" +
                  (restaurant?.restaurant_name?.split(" ").join("") || "")
                }
                value={formik.values.photos}
                removeImage={bankDocMultipleRemove}
                maxImageSize={500000}
              />
              <div className="font_12_r  mb-4 d-flex">
                Min 2 pics | Max size 500kb/pic
              </div>
            </div>{" "}
            {formik.errors.photos && formik.touched.photos ? (
              <div className="mb-3 pho_14_regular text-danger">
                {formik.errors.photos}
              </div>
            ) : (
              <div className="mb-3"> </div>
            )}
          </Col>
          <hr />
          <Col md={12}>
            <div className="event-offer-image">
              <SimpleReactLightbox>
                <MultipleImageUploadComponent
                  title="Add Video"
                  onChange={uploadMultipleVideoFiles}
                  stateValue={formik?.values?.videos}
                  removeImage={multipleVideoResetFile}
                  accept="video/*"
                  singleUpload={true}
                  videoUpload={true}
                // smallTitle="( Add Videos or 360 view of Business Establishment - If needed you can get a professional photo shoot or video to make it attractive - this will appear on user app)"
                />
                <div className="font_12_r  mb-4 d-flex">
                  (you can upload only 1 video , max size 5 MB)
                </div>
              </SimpleReactLightbox>
              {!state.progress && state.progress === 0 ? null : (
                <AlertDialogProgress
                  progress={state.progress}
                  title="Video Uploading..."
                />
              )}
            </div>
          </Col>
          <Row>
            <Col lg={8}>
              <Form.Group>
                <TextField
                  id="tc"
                  label="Terms and Conditions"
                  type="text"
                  multiline
                  helperText={
                    formik.errors.tc && formik.touched.tc
                      ? formik.errors.tc
                      : "* Max 500 Characters"
                  }
                  rows="5"
                  variant="outlined"
                  error={formik.errors.tc && formik.touched.tc}
                  className={`w-100`}
                  name="tc"
                  onChange={formik.handleChange}
                  value={formik.values.tc}
                  onBlur={formik.handleBlur}
                  isInvalid={formik.errors.tc && formik.touched.tc}
                />
                {/* {formik.errors.tc && formik.touched.tc ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.tc}
                  </div>
                ) : null} */}
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={5}>
              <RestaurantCard />
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default GeneralInformationExp;
